import type { FunctionComponent } from 'react';
import { OutboundLink } from '../../../OutboundLink/OutboundLink';

type GoogleMapPlaceLink = `https://www.google.com/maps/place/${string},${string}`;
const generateGoogleMapLink = ({
  center,
}: Readonly<{
  center: NonNullable<google.maps.MapOptions['center']>;
}>): GoogleMapPlaceLink => {
  const lat = typeof center.lat === 'function' ? center.lat() : center.lat;
  const lng = typeof center.lng === 'function' ? center.lng() : center.lng;
  return `https://www.google.com/maps/place/${lat},${lng}`;
};
export const GoogleMapLink: FunctionComponent<{
  center: google.maps.MapOptions['center'];
  outboundLinkType?: string;
}> = ({ center, outboundLinkType = 'google-map-outbound-link' }) => {
  if (!center) return null;
  const linkToGoogleMap = generateGoogleMapLink({ center });
  return (
    <OutboundLink href={linkToGoogleMap} outboundLinkType={outboundLinkType}>
      See on Google Map
    </OutboundLink>
  );
};
